import { ScrollView } from "react-native";
import Login from "./containers/Auth/Login";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store"; // Import store and persistor

export default function Auth() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ScrollView style={{ flex: 1, backgroundColor: "rgb(222, 197, 189)" }}>
          <Login />
        </ScrollView>
      </PersistGate>
    </Provider>
  );
}
